import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Brand } from "../../Domain/Model/Brand";
import { BrandRepository } from "../../Domain/Repository/BrandRepository";
import BrandDataSource from "../DataSource/BrandDataSource";

export class BrandRepositoryImpl implements BrandRepository {
  dataSource: BrandDataSource;

  constructor(_datasource: BrandDataSource) {
    this.dataSource = _datasource;
  }
  getBrandsList(): Promise<Brand[]> {
    return this.dataSource.getBrandsList();
  }
  getBrands(page:number, pageSize: number, search: string): Promise<PaginationResult<Brand>>{
        return this.dataSource.getBrands(page, pageSize, search);
    }

  createBrand(data: Brand): Promise<Brand[]> {
      return this.dataSource.createBrand(data);
  }

  removeColor(id: string): Promise<boolean> {
    return this.dataSource.removeColor(id);
  }
  updateColor(data: Brand): Promise<boolean> {
    return this.dataSource.updateColor(data);
  }
    
}